/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CheckBoxConfig } from "libs/sysque/shared/ui/src/lib/models/check-box-config";
import { SystemInfo } from "libs/sysque/toolbelt/data-access/src/lib/domain/system-info";

export class SystemState{
    systemType: SystemType
    showCategoryList=false;
    isHangerNeeded=false;
    isCableTrayClearanceNeeded = false;
    showAddFittingBtn=false;
    selectedCategory:string;
    selectedSystem:string;
    selectedPanelName:string;
    ProjectName:string;
    selectedWireFillSpecification:string;
    rotationRight:number;
    rotationLeft:number;
    rotationTop:number;
    rotationBottom:number;  
    checkBoxConfigs: CheckBoxConfig[]=[]  
    manageMode:boolean;
    addFittingMode:boolean;
    processFitting:boolean;
    processingEnabled:boolean;
    showNonStandard:boolean;
    systemList: SystemInfo[];
}

export enum SystemType{
    Panel,
    CableTray
}
